import * as _ from 'underscore';
import { Injectable } from '@angular/core';
import { util } from '../util';

@Injectable()
export class BodyClassService {
  private bodyClasses:string[] = [];

  public add(aClass:string):void {
    if (!_.contains(this.bodyClasses, aClass)) {
      this.bodyClasses.push(aClass);
    }
    this.bodyElm().addClass(aClass);
  }

  public remove(aClass:string):void {
    this.bodyClasses = _.without(this.bodyClasses, aClass);
    this.bodyElm().removeClass(aClass);
  }

  public toggle(aClass:string):void {
    if (!_.contains(this.bodyClasses, aClass)) {
      this.bodyClasses.push(aClass);
    } else {
      this.bodyClasses = _.without(this.bodyClasses, aClass);
    }
    this.bodyElm().toggleClass(aClass);
  }

  public set(aClassArray:Array<string>):void {
    const oldClasses = this.bodyClasses;
    if (_.isArray(aClassArray)) {
      this.bodyClasses = aClassArray;
    } else {
      throw 'array of classes expected';
    }
    this.update(oldClasses, this.bodyClasses);
  }

  public removeAll():void {
    const oldClasses = util.copyAndExtend(this.bodyClasses);
    this.bodyClasses = [];
    this.update(oldClasses, this.bodyClasses);
  }

  public get():Array<string> {
    return this.bodyClasses;
  }

  private bodyElm():JQuery {
    return $('body');
  }

  public update(oldClasses:Array<string>, newClasses:Array<string>) {
    const body:JQuery = this.bodyElm();

    _.forEach(_.difference(oldClasses, newClasses), cls => {
      body.removeClass(cls);
    });

    _.forEach(_.difference(newClasses, oldClasses), cls => {
      body.addClass(cls);
    });
  }
}